import React, { useState, useEffect } from "react";
import UserService from "../services/user.service"; // Adjust the import path accordingly
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Card, Spinner, Row, Col, Alert } from 'react-bootstrap';
import { useSelector } from "react-redux";
import ErrorModal from './ErrorModal';

const BoardMyDataADM = () => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [formData, setFormData] = useState({
        company_name: '',
        company_mobile_number: '',
        company_email: '',
        contact_first_name: '',
        contact_last_name: '',
        contact_mobile_number: '',
        contact_email: '',
        rec_date: ''
    });

    const [errors, setErrors] = useState({});
    const [apiErrors, setApiErrors] = useState(null);
    const [apiErrorCode, setApiErrorCode] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    // Fetch customer data when the component mounts
    useEffect(() => {
        setLoading(true);
        UserService.getAdByIdADM() // Ensure the API call reflects your actual service method
            .then((response) => {
                setFormData(response.data);
            })
            .catch((error) => handleError(error))
            .finally(() => setLoading(false));
    }, []);

    const handleError = (error) => {
        if (error.response && error.response.status === 401) {
            EventBus.dispatch("logout");
        }
        if (error.response) {
            setApiErrors(`Fehler: ${error.response.data.message}`);
            setApiErrorCode(`Fehler: ${error.name} - ${error.response.status}`);
        } else {
            setApiErrors(`Fehler: ${error.message}`);
            setApiErrorCode(`Fehler: ${error.name}`);
        }
        setShowModal(true);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.company_name.trim()) {
            newErrors.company_name = 'Firmenname ist ein Pflichtfeld';
        }
        if (!formData.company_mobile_number.trim()) {
            newErrors.company_mobile_number = 'Firmen-Mobilnummer ist ein Pflichtfeld';
        } else if (!/^(00\d{2,3}|0\d{4,}|(\+49)?\d{3,})\d{6,}$/g.test(formData.company_mobile_number)) {
            newErrors.company_mobile_number = 'Ungültige Mobilfunknummer';
        }
        if (!formData.company_email.trim()) {
            newErrors.company_email = 'Firmen-E-Mail ist ein Pflichtfeld';
        } else if (!/\S+@\S+\.\S+/.test(formData.company_email)) {
            newErrors.company_email = 'Ungültige E-Mail-Adresse';
        }
        if (!formData.contact_first_name.trim()) {
            newErrors.contact_first_name = 'Kontakt Vorname ist ein Pflichtfeld';
        }
        if (!formData.contact_last_name.trim()) {
            newErrors.contact_last_name = 'Kontakt Nachname ist ein Pflichtfeld';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            UserService.updateAdBoard(formData) // Adjust API method accordingly
                .then(() => {
                    setSuccessMessage('Vertriebspartnerdetails erfolgreich aktualisiert!');
                    setApiErrors(null);
                })
                .catch((error) => handleError(error))
                .finally(() => setLoading(false));
        }
    };

    const handleCloseModal = () => setShowModal(false);

    return (
        <Container fluid className="py-3 py-md-5">
            <Row className="justify-content-center">
                {/* Main Content */}
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <Card className="shadow-lg border-0" style={{ borderRadius: '15px' }}>
                        <Card.Header 
                            className="text-center text-white py-4" 
                            style={{ 
                                backgroundColor: '#2c3e50',
                                borderTopLeftRadius: '15px',
                                borderTopRightRadius: '15px',
                                fontSize: '1.5rem',
                                fontWeight: 'bold'
                            }}
                        >
                            <i className="bi bi-person-circle me-2"></i>
                            Meine Daten
                        </Card.Header>
                        <Card.Body className="p-4 p-md-5">
                            {loading ? (
                                <div className="text-center py-5">
                                    <Spinner animation="border" role="status" variant="primary" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Laden...</span>
                                    </Spinner>
                                </div>
                            ) : (
                                <Form onSubmit={handleSubmit}>
                                    {/* Success Alert */}
                                    {successMessage && (
                                        <Alert variant="success" dismissible onClose={() => setSuccessMessage(null)} className="mb-4">
                                            <i className="bi bi-check-circle-fill me-2"></i>
                                            {successMessage}
                                        </Alert>
                                    )}

                                    {/* Company Section */}
                                    <div className="mb-4">
                                        <h5 className="text-muted mb-3 border-bottom pb-2">
                                            <i className="bi bi-building me-2"></i>
                                            Firmendaten
                                        </h5>
                                        
                                        {/* Company Name */}
                                        <Form.Group controlId="formCompanyName" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Firmenname <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="company_name"
                                                value={formData.company_name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.company_name}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.company_name}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        {/* Mobile Number */}
                                        <Form.Group controlId="formCompanyMobile" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Firmen-Mobilnummer <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="company_mobile_number"
                                                value={formData.company_mobile_number}
                                                onChange={handleChange}
                                                isInvalid={!!errors.company_mobile_number}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                                placeholder="+49..."
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.company_mobile_number}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        {/* Company Email */}
                                        <Form.Group controlId="formCompanyEmail" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Firmen-E-Mail (Benutzername) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="company_email"
                                                value={formData.company_email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.company_email}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.company_email}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>

                                    {/* Contact Section */}
                                    <div className="mb-4">
                                        <h5 className="text-muted mb-3 border-bottom pb-2">
                                            <i className="bi bi-person me-2"></i>
                                            Kontaktdaten
                                        </h5>

                                        {/* Contact First Name */}
                                        <Form.Group controlId="formContactFirstName" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Vorname <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="contact_first_name"
                                                value={formData.contact_first_name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.contact_first_name}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.contact_first_name}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        {/* Contact Last Name */}
                                        <Form.Group controlId="formContactLastName" className="mb-3">
                                            <Form.Label className="fw-semibold">
                                                Nachname <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="contact_last_name"
                                                value={formData.contact_last_name}
                                                onChange={handleChange}
                                                isInvalid={!!errors.contact_last_name}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.contact_last_name}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        {/* Contact Mobile Number */}
                                        <Form.Group controlId="formContactMobile" className="mb-3">
                                            <Form.Label className="fw-semibold">Mobilnummer</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="contact_mobile_number"
                                                value={formData.contact_mobile_number}
                                                onChange={handleChange}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                                placeholder="+49..."
                                            />
                                        </Form.Group>

                                        {/* Contact Email */}
                                        <Form.Group controlId="formContactEmail" className="mb-3">
                                            <Form.Label className="fw-semibold">E-Mail</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="contact_email"
                                                value={formData.contact_email}
                                                onChange={handleChange}
                                                size="lg"
                                                style={{ fontSize: '1.1rem' }}
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* Registration Date */}
                                    <Form.Group controlId="formRecDate" className="mb-4">
                                        <Form.Label className="fw-semibold">
                                            <i className="bi bi-calendar3 me-2"></i>
                                            Registrierungsdatum
                                        </Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="rec_date"
                                            value={formData.rec_date}
                                            onChange={handleChange}
                                            size="lg"
                                            style={{ fontSize: '1.1rem' }}
                                        />
                                    </Form.Group>

                                    <div className="d-grid">
                                        <Button 
                                            type="submit" 
                                            disabled={loading}
                                            size="lg"
                                            style={{ 
                                                backgroundColor: '#2c3e50',
                                                borderColor: '#2c3e50',
                                                fontSize: '1.2rem',
                                                padding: '12px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner animation="border" size="sm" className="me-2" />
                                                    Wird aktualisiert...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-check-lg me-2"></i>
                                                    Aktualisieren
                                                </>
                                            )}
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                {/* Error and Success Message Modal */}
                <ErrorModal show={showModal} onHide={handleCloseModal} apiErrors={apiErrors} apiErrorCode={apiErrorCode} successMessage={successMessage} />

            </Row>
        </Container>
    );
};

export default BoardMyDataADM;